import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { SearchModel } from 'src/app/models/search-model';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CheckoutsFacade } from 'src/app/state/user/checkouts/checkouts.facade';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-user-checkouts',
  templateUrl: './user-checkouts.component.html',
  styleUrls: ['./user-checkouts.component.scss'],
})
export class UserCheckoutsComponent implements OnInit {
  private readonly configService = inject(ConfigService);

  @Output()
  submitted: EventEmitter<boolean> = new EventEmitter();

  searchModel: SearchModel;

  section = 'checkouts';
  userService: UserService;
  progressLoaded: boolean;

  isLoading = true;

  readonly checkouts$ = this.checkoutsFacade.checkouts$;

  constructor(
    userService: UserService,
    private router: Router,
    private apiService: ApiService,
    private checkoutsFacade: CheckoutsFacade
  ) {
    this.userService = userService;
  }

  ngOnInit() {
    this.apiService.getPatronCheckoutsProgress(this.userService.getUserId()).subscribe((resourcesProgress) => {
      resourcesProgress.forEach((resourcesProgress) => {
        this.checkoutsFacade.checkouts.forEach((checkoutItem) => {
          if (checkoutItem.recordId === resourcesProgress.nInf && checkoutItem.percentage === undefined) {
            checkoutItem.percentage = resourcesProgress.percentage;
            this.checkoutsFacade.setCheckout(checkoutItem);
          }
        });
      });
      this.isLoading = false;
    });
  }

  explore() {
    const model = new SearchModel(undefined, this.configService.get().resultsFilterOrder);
    model.explore = true;

    this.submitted.emit(true);
    this.router.navigate(['/results'], {
      queryParams: model.toRequest(),
    });
  }
}
